// libs
import React from 'react';
import cx from 'classnames';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
//style
import style from './StepNavigator.module.scss';
const getDlsVariant = (currentStep, activeStep) => {
    if (currentStep === activeStep) {
        return DlsFontVariants.body_B1_Bold;
    }
    return DlsFontVariants.body_B1_Med;
};
const getDlsColor = (currentStep, activeStep) => {
    if (currentStep === activeStep) {
        return DlsColorTokens.text_Highest_Emphasis;
    }
    return DlsColorTokens.text_Med_Emphasis;
};
const StepNavigator = ({ steps, activeStep, setActiveStep }) => {
    const getClassNames = (index) => {
        return {
            [style.cStepperItem]: true,
            [style.activeStep]: index === activeStep,
            [style.completedStep]: index < activeStep,
        };
    };
    return (React.createElement("ol", { className: style.cStepper }, steps
        .filter((step) => !step.hideInNav)
        .map((step, index) => {
        const handleNavItemClick = () => {
            if (index < activeStep) {
                setActiveStep(index);
            }
        };
        return (React.createElement("li", { className: cx(getClassNames(index)), onClick: handleNavItemClick, key: step.title },
            React.createElement(Text, { variant: getDlsVariant(index, activeStep), color: getDlsColor(index, activeStep), className: style.cStepperTitle }, step.title)));
    })));
};
export default StepNavigator;
